export default "__VITE_ASSET__b4239fad__"